module.exports = __webpack_public_path__ + "img/member07.9029adb6.png";